<section class="container">
  <h2 class="section-title">CSV インポート</h2>
  <p class="description">
    BlueBean 管理画面でエクスポートしたオペレーター一覧 CSV を加工せずに
    アップロードしてください。CSV の内容で既存マッピングを全置換します。
  </p>

  <div class="upload">
    <label class="upload-button">
      <input
        type="file"
        accept=".csv,text/csv"
        (change)="this.onFileSelected($event)"
        [disabled]="this.isImporting"
      />
      <span>CSV を選択してアップロード</span>
    </label>
    @if (this.isImporting) {
      <span class="importing">アップロード中…</span>
    }
  </div>

  @if (this.importResult) {
    <div class="result" aria-live="polite">
      <h3 class="result-title">インポート結果</h3>
      <ul class="result-list">
        <li>取り込み件数: {{ this.importResult.imported }} 件</li>
        <li>
          BlueBean上でメールアドレス未設定のためスキップした件数:
          {{ this.importResult.skippedNoEmail }} 件
        </li>
        <li>
          AI Sales Coach に未登録のメールアドレスのためスキップした件数:
          {{ this.importResult.skippedUnregistered }} 件
        </li>
        <li>削除済件数: {{ this.importResult.deletedMappingCount }} 件</li>
      </ul>
      @if (this.importResult.errors.length > 0) {
        <div class="error-rows">
          <h4 class="error-title">スキップした行</h4>
          <table
            mat-table
            [dataSource]="this.importResult.errors"
            class="error-table"
          >
            <ng-container matColumnDef="rowNumber">
              <th mat-header-cell *matHeaderCellDef>行番号</th>
              <td mat-cell *matCellDef="let row">{{ row.rowNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="operatorId">
              <th mat-header-cell *matHeaderCellDef>operator_id</th>
              <td mat-cell *matCellDef="let row">{{ row.operatorId }}</td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>メールアドレス</th>
              <td mat-cell *matCellDef="let row">{{ row.email }}</td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th mat-header-cell *matHeaderCellDef>スキップ理由</th>
              <td mat-cell *matCellDef="let row">
                @if (row.reason === this.skipReason.NoEmail) {
                  BlueBean上のメールアドレス未設定
                }
                @if (row.reason === this.skipReason.UnregisteredEmail) {
                  AI Sales Coach に未登録のメールアドレス
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="this.errorColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: this.errorColumns"></tr>
          </table>
        </div>
      }
    </div>
  }

  <h2 class="section-title">現在のマッピング一覧</h2>
  <app-loading [showLoading]="this.isLoading"></app-loading>

  @if (!this.isLoading) {
    <div>
      @if (this.mappings.length === 0) {
        <p class="empty">マッピングは登録されていません。</p>
      }
      @if (this.mappings.length > 0) {
        <table mat-table [dataSource]="this.mappings" class="mapping-table">
          <ng-container matColumnDef="operatorId">
            <th mat-header-cell *matHeaderCellDef>operator_id</th>
            <td mat-cell *matCellDef="let row">{{ row.operatorId }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>ユーザー名</th>
            <td mat-cell *matCellDef="let row">{{ row.user.name }}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>メールアドレス</th>
            <td mat-cell *matCellDef="let row">{{ row.user.email }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="this.mappingColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: this.mappingColumns"></tr>
        </table>
      }
    </div>
  }
</section>
